// src/components/charts/ApalancamientoChart.jsx
import React, { useState, useEffect } from 'react';
import { Card, Alert, Spinner } from 'react-bootstrap';
import DonutChart from '../agComponents/DonutChart';
import kpiService from '../../services/kpiService';

/**
 * Componente que muestra el apalancamiento por área (gráfico dona)
 */
const ApalancamientoChart = ({ fechaInicio, fechaFin, empresaId }) => {
  const [chartData, setChartData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await kpiService.getApalancamientoPorArea({
          fechaInicio,
          fechaFin,
          empresaId,
        });

        if (response.success && response.data) {
  // Si response.data tiene una propiedad 'data', usar esa
  const dataArray = response.data.data || response.data;
  
  if (Array.isArray(dataArray)) {
    setChartData(dataArray);
  } else {
    console.warn('Data no es un array:', response.data);
    setChartData([]);
  }
} else {
          throw new Error('No se pudieron cargar los datos');
        }
      } catch (err) {
        console.error('Error fetching apalancamiento:', err);
        setError('Error al cargar el gráfico. Por favor, intenta nuevamente.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [fechaInicio, fechaFin, empresaId]);

  if (error) {
    return (
      <Card>
        <Card.Body>
          <Alert variant="danger">{error}</Alert>
        </Card.Body>
      </Card>
    );
  }

  if (loading) {
    return (
      <Card>
        <Card.Body className="text-center py-5">
          <Spinner animation="border" variant="primary" />
          <p className="mt-3 text-muted">Cargando datos...</p>
        </Card.Body>
      </Card>
    );
  }

  // ✅ FIX: Validar que chartData existe y es array antes de hacer reduce
  if (!chartData || !Array.isArray(chartData) || chartData.length === 0) {
    return (
      <Card>
        <Card.Body>
          <Alert variant="info">No hay datos disponibles para el período seleccionado</Alert>
        </Card.Body>
      </Card>
    );
  }

  // ✅ FIX: Ahora chartData.reduce es seguro porque sabemos que es un array
  const totalValue = chartData.reduce((acc, item) => acc + (parseFloat(item.value) || 0), 0);

  return (
    <Card>
      <Card.Body>
        <h5 className="mb-4">Apalancamiento por área</h5>
        
        <DonutChart
          data={chartData}
          angleKey="value"
          labelKey="label"
          height={300}
          innerRadiusRatio={0.65}
        />

        {/* Leyenda personalizada con porcentajes */}
        <div className="mt-4">
          <div className="d-flex flex-column gap-2">
            {chartData.map((item, idx) => {
              const percentage = totalValue > 0 
                ? ((parseFloat(item.value) / totalValue) * 100).toFixed(1) 
                : 0;
              
              return (
                <div key={idx} className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center gap-2">
                    <div
                      style={{
                        width: '12px',
                        height: '12px',
                        borderRadius: '50%',
                        backgroundColor: item.color,
                      }}
                    />
                    <span className="small">{item.label || item.area}</span>
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <span className="fw-semibold">{percentage}%</span>
                    <span className="text-muted small">
                      ({parseFloat(item.value || 0).toLocaleString('es-ES', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      })} €)
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Total */}
        <div className="mt-3 pt-3 border-top text-center">
          <div className="text-muted small">Total Apalancamiento</div>
          <div className="h4 mb-0">
            {totalValue.toLocaleString('es-ES', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })} €
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default ApalancamientoChart;